module.exports = __webpack_public_path__ + "img/avatar.d6a1041.png";